import { render } from "./mobileAddRepair.vue?vue&type=template&id=fae617f4&scoped=true"
import script from "./mobileAddRepair.vue?vue&type=script&lang=js"
export * from "./mobileAddRepair.vue?vue&type=script&lang=js"

import "./mobileAddRepair.vue?vue&type=style&index=0&id=fae617f4&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fae617f4"]])

export default __exports__